import { frontendURL } from 'dashboard/helper/URLHelper';
import InboxListView from './InboxList.vue';
import InboxEmptyStateView from './InboxEmptyState.vue';
import EmailThreadView from 'dashboard/components-next/Inbox/Email/EmailThreadView.vue';
import { ROLES } from 'dashboard/constants/permissions.js';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/inbox-view'),
    component: InboxListView,
    children: [
      {
        path: '',
        name: 'inbox_view',
        component: InboxEmptyStateView,
        meta: {
          permissions: [...ROLES, 'inbox_manage'],
          pagePermission: 'page_inbox',
        },
      },
      // Aceleres: aba E-mails. Antes de `:type/:id` para ficar claro que o
      // segmento fixo `email` nunca e lido como tipo de notificacao.
      {
        path: 'email/:id',
        name: 'inbox_view_email_thread',
        component: EmailThreadView,
        meta: {
          permissions: [...ROLES, 'inbox_manage'],
          pagePermission: 'page_inbox',
        },
      },
      {
        path: ':type/:id',
        name: 'inbox_view_conversation',
        component: () => import('./InboxView.vue'),
        meta: {
          permissions: [...ROLES, 'inbox_manage'],
          pagePermission: 'page_inbox',
        },
      },
    ],
  },
];
